import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang'
    }),
    externalLinkLang () {
      const mapping = {
        zh_TW: 'zh_tw',
        ja: 'ja'
      }
      return mapping[this.selectedLang] ? mapping[this.selectedLang] : 'en'
    },
    isTraditionalChinese () {
      return this.selectedLang === 'zh_TW'
    }
  },
  methods: {
    getLogo () {
      if (this.isTraditionalChinese) {
        return require('@/assets/images/logos/logo-tw.svg')
      }
      return require('@/assets/images/logos/logo-en.svg')
    },
    getWhiteLogo () {
      if (this.isTraditionalChinese) {
        return require('@/assets/images/logos/logo-tw-white.svg')
      }
      return require('@/assets/images/logos/logo-en-white.svg')
    }
  }
}
